import { render } from "./newLicense.vue?vue&type=template&id=7524e376"
import script from "./newLicense.vue?vue&type=script&lang=js"
export * from "./newLicense.vue?vue&type=script&lang=js"

import "./newLicense.vue?vue&type=style&index=0&id=7524e376&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__